<template>
  <div class="hero">
    <div class="container">
      <div class="row">
        <div class="col-md-6 text-blog">
          <h2>Family and Friends</h2>
          <p>
            As we celebrate the extraordinary journey of our beloved Derriana's
            Sweet 16, we've come together to create a special space filled with
            love, laughter, and cherished memories. Our blog is a collection of
            heartfelt articles penned by the people who hold Derriana close to
            their hearts. Each entry is a unique expression of the impact she
            has had on our lives, the joy she brings, and the dreams we hold for
            her future. From funny anecdotes to poignant reflections, this blog
            is a testament to the incredible person Derriana is becoming. Join
            us in sharing the love and joy as we chronicle this momentous
            occasion and create a digital scrapbook that will forever capture
            the essence of Derriana's Sweet 16.
          </p>
          <p>
            Cheers to Derriana and the beautiful journey ahead!
          </p>
          <p>
            With love,
          </p>
          <p>
            Your Family 🌟 #Sweet16Chronicles #CelebratingDerriana
          </p>
          <button
            v-if="false"
            @click="handleGetStartedClick"
            class="btn btn-outline"
          >
            Join Us
          </button>
          <b-button
              pill
              style="background-color: #b2ac88"
              @click="handleToggleSidebar">
            <b-icon icon="pencil" font-scale="1"/>
            Write Your Blog
          </b-button>
        </div>
        <div class="col-md-6 img-blog">
          <b-img
            thumbnail
            fluid
            src="/assets/_birthday/dwithcake.jpeg"
            alt="Tink and Friends"
          />
        </div>
      </div>
    </div>
    <b-sidebar
               :ref="sidebarId"
               :id="sidebarId"
               right
               width="80%"
               no-header
               shadow
    >
      <div class="px-3 py-2" style="background-color: #b2ac88; height: 100vh">
        <add-edit-form-blog
            @close-sidebar="handleToggleSidebar"
            @item-added="handleBlogAdded"
        />
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import AddEditFormBlog from "./addEditItemForm"
export default {
  name: "Hero",
  components:{
    AddEditFormBlog
  },
  methods: {
    handleGetStartedClick() {
      this.$router.push("/signup");
    },
    handleToggleSidebar() {
      this.$root.$emit('bv::toggle::collapse', this.sidebarId);
    },
    handleBlogAdded(){
      this.handleToggleSidebar();
      this.$emit("item-added");
    }
  },
  data() {
    return {
      sidebarId:'post-blog-sidebar'
    };
  },
};
</script>

<style lang="scss" scoped>
.hero {
  background-color: #f7fafd;
  .text-blog {
    min-height: 452px;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
    h2 {
      font-style: normal;
      font-weight: normal;
      font-size: 48px;
      line-height: 129.7%;
      color: #474d52;
      margin-bottom: 16px;
    }
    p {
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 22px;
      color: #474d52;
      margin-bottom: 24px;
    }
    .btn-outline {
      height: 35px;
      text-transform: capitalize;
      border: 1px solid #557efb;
      border-radius: 4px;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 19px;
      color: #557efb;
      padding: 8px 16px;
      &:hover {
        &:before,
        &:after {
          content: none;
        }

        background-color: #557efb;
        color: #fff;
      }
    }
  }
  .img-blog {
    min-height: 452px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
@media (max-width: 767px) {
  .hero {
    .text-blog {
      padding-top: 60px;
      min-height: unset;
    }
    .img-blog {
      margin-top: 60px;
      min-height: unset;
      img {
        max-height: 250px;
      }
    }
  }
}
</style>
